"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.shouldNotForwardProp = exports.shouldForwardProp = void 0;
var _isPropValid = _interopRequireDefault(require("@emotion/is-prop-valid"));
var shouldForwardProp = function() {
    var allowedProps = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return function(prop) {
        if (allowedProps.includes(prop)) {
            return true;
        }
        return (0, _isPropValid.default)(String(prop));
    };
};
exports.shouldForwardProp = shouldForwardProp;
var shouldNotForwardProp = function() {
    var forbiddenProps = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return function(prop) {
        return !forbiddenProps.includes(prop);
    };
};
exports.shouldNotForwardProp = shouldNotForwardProp; //# sourceMappingURL=shouldForwardProp.js.map
